import { reportFallbackBiEvent } from './bi';
export const webReporter = (url, fetchFn) => payload => {
  try {
    const batchPayload = Array.isArray(payload) ? payload : [payload];
    const body = JSON.stringify({
      messages: batchPayload
    });
    const fetchParams = {
      method: 'POST',
      body
    };
    if (fetchFn) {
      fetchFn(url, fetchParams).catch(e => {
        console.error(e);
      });
      return true;
    }
    const res = navigator.sendBeacon(url, body);
    if (!res) {
      fetch(url, fetchParams);

      // Report a BI event so we know this fallback occurred
      reportFallbackBiEvent(batchPayload, body);
      return true;
    }
    return res;
  } catch (e) {
    console.error(e);
    return false;
  }
};
//# sourceMappingURL=reporter.js.map